"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useCreateAttachmentForScreenReaderRenderer;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useCreateAttachmentForScreenReaderRenderer() {
  return (0, _useWebChatAPIContext.default)().attachmentForScreenReaderRenderer;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VDcmVhdGVBdHRhY2htZW50Rm9yU2NyZWVuUmVhZGVyUmVuZGVyZXIuanMiXSwibmFtZXMiOlsidXNlQ3JlYXRlQXR0YWNobWVudEZvclNjcmVlblJlYWRlclJlbmRlcmVyIiwiYXR0YWNobWVudEZvclNjcmVlblJlYWRlclJlbmRlcmVyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSwwQ0FBVCxHQUFzRDtBQUNuRSxTQUFPLHFDQUF1QkMsaUNBQTlCO0FBQ0QiLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VXZWJDaGF0QVBJQ29udGV4dCBmcm9tICcuL2ludGVybmFsL3VzZVdlYkNoYXRBUElDb250ZXh0JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlQ3JlYXRlQXR0YWNobWVudEZvclNjcmVlblJlYWRlclJlbmRlcmVyKCkge1xuICByZXR1cm4gdXNlV2ViQ2hhdEFQSUNvbnRleHQoKS5hdHRhY2htZW50Rm9yU2NyZWVuUmVhZGVyUmVuZGVyZXI7XG59XG4iXX0=